import { render, staticRenderFns } from "./confirm-redemption.vue?vue&type=template&id=26456f05&scoped=true&"
import script from "./confirm-redemption.vue?vue&type=script&lang=js&"
export * from "./confirm-redemption.vue?vue&type=script&lang=js&"
import style0 from "./confirm-redemption.vue?vue&type=style&index=0&id=26456f05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26456f05",
  null
  
)

export default component.exports